// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';
import { TypeServiceModel } from '../../symbols';

export interface TypesServiceStateModel {
  typesService: TypeServiceModel[];
  loadTypesServiceStatus: PROGRESS_STATUSES
}

export const TYPES_SERVICE_STATE_DEFAULT: TypesServiceStateModel = {
  typesService: [],
  loadTypesServiceStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
